var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-box-content"},[_c('img',{attrs:{"src":require("@/assets/images/google-logo.svg"),"alt":""}}),_c('Carousel',{attrs:{"ADS":_vm.ads}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }